import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-trip-icon-lock-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './trip-icon-lock-dialog.component.html',
  styleUrls: ['./trip-icon-lock-dialog.component.scss'],
})
export class TripIconLockDialogComponent implements AfterViewInit, OnDestroy {
  @ViewChild('apologyInput') apologyInput?: ElementRef<HTMLInputElement>;
  readonly requiredApology = "Sorry, I won't change it.";
  apology = '';
  private focusTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private dialogRef: MatDialogRef<TripIconLockDialogComponent>) {}

  get canClose(): boolean {
    return this.apology.trim() === this.requiredApology;
  }

  ngAfterViewInit(): void {
    const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 4900;
    this.focusTimer = setTimeout(() => this.apologyInput?.nativeElement.focus({ preventScroll: true }), delay);
  }

  close(): void {
    if (this.canClose) this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.focusTimer !== null) clearTimeout(this.focusTimer);
  }
}
